export function isDataURL(s) {
  return !!s.match(isDataURL.regex);
}
// eslint-disable-next-line 
isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;




// WEBPACK FOOTER //
// ./src/fw/forms/controls/avatar/utils.js